import { styled } from '@material-ui/core';
import BottomNavigationActionInternal from '@material-ui/core/BottomNavigationAction';

const BottomNavigationAction = styled(BottomNavigationActionInternal)({
  padding: '6px 12px 0 12px',
});
export { BottomNavigationAction };
